module.exports = __webpack_public_path__ + "static/sifter-9e5e9890d267f5ec9d324baefeeb9cdb.png";